module.exports = __webpack_public_path__ + "img/heart_structureFunction_summary.7e063af6.png";